var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.5C9.11866 12.5 10.9375 10.6812 10.9375 8.4375C10.9375 6.19384 9.11866 4.375 6.875 4.375C4.63134 4.375 2.8125 6.19384 2.8125 8.4375C2.8125 10.6812 4.63134 12.5 6.875 12.5Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1416 4.52634C12.7004 4.36891 13.2864 4.33305 13.8602 4.42117C14.434 4.50929 14.9822 4.71934 15.468 5.03719C15.9538 5.35503 16.3658 5.77329 16.6763 6.26378C16.9868 6.75427 17.1886 7.30561 17.2681 7.88066C17.3476 8.45571 17.303 9.04112 17.1372 9.59746C16.9714 10.1538 16.6883 10.6682 16.307 11.1059C15.9256 11.5436 15.4549 11.8945 14.9266 12.135C14.3982 12.3755 13.8244 12.4999 13.2439 12.5",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24951 15.4216C1.88399 14.5191 2.7263 13.7825 3.70533 13.274C4.68436 12.7655 5.77137 12.5 6.87458 12.5C7.97779 12.5 9.06481 12.7654 10.0439 13.2738C11.023 13.7822 11.8653 14.5187 12.4999 15.4212",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2441 12.5C14.3475 12.4992 15.4347 12.7643 16.4139 13.2728C17.393 13.7813 18.2352 14.5182 18.8692 15.4212",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.6dc09ecba4ac9de84a3361c962434ce0.svg";
export { ForwardRef as ReactComponent };